import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { Avatar, AvatarFallback, AvatarImage, ComboboxOptionRenderProps } from "@tellescope/ui";
import { formatInitials, formatName } from "@tellescope/utils";

export interface InboxChatRecipientItemProps extends ComboboxOptionRenderProps<string> {
  enduser?: TellescopeModelFromName<"endusers">;
}

export const InboxChatRecipientItem = ({ enduser }: InboxChatRecipientItemProps) => {
  return (
    <div className="flex gap-2 items-center">
      {!!enduser && (
        <Avatar>
          <AvatarImage src={enduser.avatar} />
          <AvatarFallback>{formatInitials(enduser)}</AvatarFallback>
        </Avatar>
      )}
      <div className="flex flex-col">{!!enduser && <p className="font-semibold">{formatName(enduser)}</p>}</div>
    </div>
  );
};
